document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', e => {
      const target = document.querySelector(a.getAttribute('href'));
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth' }); }
    });
  });

  const cartToggle = document.querySelector('[data-cart-toggle]');
  const cartDropdown = document.querySelector('[data-cart-dropdown]');
  if (cartToggle && cartDropdown) {
    cartToggle.addEventListener('click', function(e) {
      e.stopPropagation();
      cartDropdown.classList.toggle('open');
    });
    document.addEventListener('click', function(e) {
      if (!cartDropdown.contains(e.target) && !cartToggle.contains(e.target)) {
        cartDropdown.classList.remove('open');
      }
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') { cartDropdown.classList.remove('open'); }
    });
  }

  const mobileNavToggle = document.querySelector('[data-mobile-nav-toggle]');
  const mobileNav = document.querySelector('[data-mobile-nav]');
  if (mobileNavToggle && mobileNav) {
    mobileNavToggle.addEventListener('click', function(e) {
      e.stopPropagation();
      mobileNav.classList.toggle('open');
      mobileNavToggle.classList.toggle('open');
    });
    mobileNav.querySelectorAll('a').forEach(a => {
      a.addEventListener('click', function() {
        mobileNav.classList.remove('open');
        mobileNavToggle.classList.remove('open');
      });
    });
    document.addEventListener('click', function(e) {
      if (!mobileNav.contains(e.target) && !mobileNavToggle.contains(e.target)) {
        mobileNav.classList.remove('open');
        mobileNavToggle.classList.remove('open');
      }
    });
  }

  const sizeSelector = document.querySelector('[data-size-selector]');
  if (sizeSelector) {
    const hiddenInput = document.querySelector('[data-selected-variant]');
    const options = Array.from(sizeSelector.querySelectorAll('.size-option'));
    let defaultSet = false;
    options.forEach(function(opt) {
      if (!defaultSet && !opt.classList.contains('sold-out')) {
        opt.classList.add('active');
        if (hiddenInput) hiddenInput.value = opt.dataset.variantId;
        defaultSet = true;
      }
      opt.addEventListener('click', function() {
        if (opt.classList.contains('sold-out')) return;
        options.forEach(function(o) { o.classList.remove('active'); });
        opt.classList.add('active');
        if (hiddenInput) hiddenInput.value = opt.dataset.variantId;
      });
    });
  }

  const desc = document.querySelector('[data-product-desc]');
  if (desc) {
    const headers = Array.from(desc.querySelectorAll('h3'));
    headers.forEach(function(h3) {
      const wrapper = document.createElement('div');
      wrapper.className = 'accordion-section';
      const header = document.createElement('button');
      header.type = 'button';
      header.className = 'accordion-header';
      header.textContent = h3.textContent;
      const panel = document.createElement('div');
      panel.className = 'accordion-panel';
      const panelInner = document.createElement('div');
      panelInner.className = 'accordion-panel-inner';
      panel.appendChild(panelInner);

      const toMove = [];
      let next = h3.nextElementSibling;
      while (next && next.tagName !== 'H3') {
        toMove.push(next);
        next = next.nextElementSibling;
      }

      h3.parentNode.insertBefore(wrapper, h3);
      wrapper.appendChild(header);
      wrapper.appendChild(panel);
      toMove.forEach(function(el) { panelInner.appendChild(el); });
      h3.remove();

      header.addEventListener('click', function() {
        wrapper.classList.toggle('open');
      });
    });
  }

  const galleryGrid = document.querySelector('[data-product-gallery-grid]');
  const swipePrev = document.querySelector('[data-swipe-prev]');
  const swipeNext = document.querySelector('[data-swipe-next]');
  if (galleryGrid && (swipePrev || swipeNext)) {
    const slides = Array.from(galleryGrid.children);
    function currentIndex() {
      let closest = 0;
      let closestDist = Infinity;
      slides.forEach(function(slide, i) {
        const dist = Math.abs(slide.offsetLeft - galleryGrid.scrollLeft);
        if (dist < closestDist) { closestDist = dist; closest = i; }
      });
      return closest;
    }
    function goToSlide(index) {
      if (index < 0) index = 0;
      if (index >= slides.length) index = slides.length - 1;
      slides[index].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
    }
    if (swipePrev) swipePrev.addEventListener('click', function() { goToSlide(currentIndex() - 1); });
    if (swipeNext) swipeNext.addEventListener('click', function() { goToSlide(currentIndex() + 1); });
  }

  const lightbox = document.querySelector('[data-lightbox]');
  if (lightbox) {
    const lbGallery = lightbox.querySelector('[data-lightbox-gallery]');
    const lbSlides = Array.from(lbGallery.querySelectorAll('.lightbox-slide'));
    const lbClose = lightbox.querySelector('[data-lightbox-close]');
    const lbPrev = lightbox.querySelector('[data-lightbox-prev]');
    const lbNext = lightbox.querySelector('[data-lightbox-next]');
    let lbCurrent = 0;

    function resetZoom() {
      lbSlides.forEach(function(slide) {
        const img = slide.querySelector('img');
        img.classList.remove('zoomed');
        slide.scrollLeft = 0;
        slide.scrollTop = 0;
      });
    }

    function openLightbox(index) {
      lbCurrent = index;
      lightbox.classList.add('open');
      document.body.style.overflow = 'hidden';
      lbSlides[index].scrollIntoView({ behavior: 'instant', inline: 'start', block: 'nearest' });
    }
    function closeLightbox() {
      lightbox.classList.remove('open');
      document.body.style.overflow = '';
      resetZoom();
    }
    function goTo(index) {
      if (index < 0) index = lbSlides.length - 1;
      if (index >= lbSlides.length) index = 0;
      lbCurrent = index;
      resetZoom();
      lbSlides[index].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
    }

    document.querySelectorAll('[data-lightbox-trigger]').forEach(function(trigger) {
      trigger.addEventListener('click', function() {
        openLightbox(parseInt(trigger.dataset.index, 10) || 0);
      });
    });

    lbSlides.forEach(function(slide) {
      const img = slide.querySelector('img');
      let dragging = false;
      let moved = false;
      let startX = 0, startY = 0, startScrollLeft = 0, startScrollTop = 0;

      img.addEventListener('click', function(e) {
        if (moved) { moved = false; return; }
        const wasZoomed = img.classList.contains('zoomed');
        img.classList.toggle('zoomed');
        if (!wasZoomed) {
          const rect = img.getBoundingClientRect();
          const clickXRatio = (e.clientX - rect.left) / rect.width;
          const clickYRatio = (e.clientY - rect.top) / rect.height;
          requestAnimationFrame(function() {
            slide.scrollLeft = (img.offsetWidth * clickXRatio) - (slide.clientWidth / 2);
            slide.scrollTop = (img.offsetHeight * clickYRatio) - (slide.clientHeight / 2);
          });
        } else {
          slide.scrollLeft = 0;
          slide.scrollTop = 0;
        }
      });

      img.addEventListener('mousedown', function(e) {
        if (!img.classList.contains('zoomed')) return;
        dragging = true;
        moved = false;
        startX = e.pageX;
        startY = e.pageY;
        startScrollLeft = slide.scrollLeft;
        startScrollTop = slide.scrollTop;
        img.style.cursor = 'grabbing';
        e.preventDefault();
      });
      document.addEventListener('mousemove', function(e) {
        if (!dragging) return;
        const dx = e.pageX - startX;
        const dy = e.pageY - startY;
        if (Math.abs(dx) > 3 || Math.abs(dy) > 3) moved = true;
        slide.scrollLeft = startScrollLeft - dx;
        slide.scrollTop = startScrollTop - dy;
      });
      document.addEventListener('mouseup', function() {
        if (dragging) {
          dragging = false;
          img.style.cursor = img.classList.contains('zoomed') ? 'zoom-out' : 'zoom-in';
        }
      });
    });

    if (lbClose) lbClose.addEventListener('click', closeLightbox);
    if (lbPrev) lbPrev.addEventListener('click', function() { goTo(lbCurrent - 1); });
    if (lbNext) lbNext.addEventListener('click', function() { goTo(lbCurrent + 1); });
    lightbox.addEventListener('click', function(e) {
      if (e.target === lightbox) closeLightbox();
    });
    document.addEventListener('keydown', function(e) {
      if (!lightbox.classList.contains('open')) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') goTo(lbCurrent - 1);
      if (e.key === 'ArrowRight') goTo(lbCurrent + 1);
    });
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function renderCartDropdown(cart) {
    const dropdown = document.querySelector('[data-cart-dropdown]');
    const toggle = document.querySelector('[data-cart-toggle]');
    if (!dropdown) return;
    if (toggle) toggle.textContent = 'cart (' + cart.item_count + ')';
    if (!cart.item_count) {
      dropdown.innerHTML = '<p class="cart-dropdown-empty">your cart is empty.</p>';
      return;
    }
    let itemsHtml = '<div class="cart-dropdown-items">';
    cart.items.forEach(function(item, i) {
      const variantHtml = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<div class="cart-dropdown-item-variant">' + item.variant_title.toLowerCase() + '</div>' : '';
      const imgHtml = item.image ? '<img src="' + item.image + '" alt="' + item.product_title + '">' : '';
      itemsHtml += '<div class="cart-dropdown-item">' +
        '<div class="cart-dropdown-item-img">' + imgHtml + '</div>' +
        '<div class="cart-dropdown-item-info">' +
        '<div class="cart-dropdown-item-title">' + item.product_title.toLowerCase() + '</div>' +
        variantHtml +
        '<div class="cart-dropdown-item-qty">qty ' + item.quantity + '</div>' +
        '<div class="cart-dropdown-item-price">' + formatMoney(item.line_price) + '</div>' +
        '</div>' +
        '<button type="button" class="cart-dropdown-item-remove" data-cart-remove-line="' + (i + 1) + '" aria-label="remove">&times;</button>' +
        '</div>';
    });
    itemsHtml += '</div>';
    const subtotalHtml = '<div class="cart-dropdown-subtotal"><span>subtotal</span><span>' + formatMoney(cart.total_price) + '</span></div>';
    const actionsHtml = '<a href="/cart" class="btn-secondary">view cart</a><a href="/checkout" class="btn-primary">checkout</a>';
    dropdown.innerHTML = itemsHtml + subtotalHtml + actionsHtml;
  }

  function removeCartLine(line, triggerBtn) {
    if (triggerBtn) triggerBtn.style.opacity = '0.4';
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: 0 })
    })
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        renderCartDropdown(cart);
        const dropdown = document.querySelector('[data-cart-dropdown]');
        if (dropdown) dropdown.classList.add('open');
      })
      .catch(function() {
        if (triggerBtn) triggerBtn.style.opacity = '1';
      });
  }

  document.addEventListener('click', function(e) {
    const removeBtn = e.target.closest('[data-cart-remove-line]');
    if (!removeBtn) return;
    e.preventDefault();
    e.stopPropagation();
    const line = parseInt(removeBtn.dataset.cartRemoveLine, 10);
    if (line) removeCartLine(line, removeBtn);
  });

  const productForm = document.querySelector('[data-product-form]');
  if (productForm) {
    productForm.addEventListener('submit', function(e) {
      e.preventDefault();
      const btn = productForm.querySelector('[data-add-to-cart-btn]');
      const errorEl = productForm.querySelector('[data-cart-form-error]');
      if (errorEl) errorEl.textContent = '';
      if (btn) { btn.disabled = true; btn.textContent = btn.dataset.loadingText || 'adding\u2026'; }

      const formData = new FormData(productForm);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      })
        .then(function(res) { return res.json().then(function(data) { return { ok: res.ok, data: data }; }); })
        .then(function(result) {
          if (!result.ok) {
            throw new Error(result.data.description || result.data.message || 'unable to add to cart');
          }
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function(r) { return r.json(); });
        })
        .then(function(cart) {
          renderCartDropdown(cart);
          const dropdown = document.querySelector('[data-cart-dropdown]');
          if (dropdown) dropdown.classList.add('open');
          if (btn) { btn.disabled = false; btn.textContent = btn.dataset.idleText || 'add to cart'; }
        })
        .catch(function(err) {
          if (errorEl) errorEl.textContent = err.message;
          if (btn) { btn.disabled = false; btn.textContent = btn.dataset.idleText || 'add to cart'; }
        });
    });
  }
});